import { c as _c } from "react/compiler-runtime";
import { ModalTypeEnum, useModal } from "@/components/providers/modal-provider/ModalProvider";
import { useIsMobile } from "@/hooks/use-mobile";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslations } from "next-intl";
import { SpecificLocationModalContent } from "./SpecificLocationModalContent";
import type { RequiredBadgeStatus } from "@/components/atoms/Form/RequiredBadge/RequiredBadge";
type UseFormGeoLocationInputProps = {
  onPickLocation?: () => void;
};
export function useFormGeoLocationInput(t0) {
  const $ = _c(24);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    onPickLocation
  } = t1;
  const {
    openModal
  } = useModal();
  const form = useFormContext();
  const isMobile = useIsMobile();
  const t = useTranslations("modules.listings.addRoomListing.houseDetails");
  let t2;
  if ($[2] !== form.control) {
    t2 = {
      control: form.control,
      name: "latitude"
    };
    $[2] = form.control;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const latitude = useWatch(t2);
  let t3;
  if ($[4] !== form.control) {
    t3 = {
      control: form.control,
      name: "longitude"
    };
    $[4] = form.control;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const longitude = useWatch(t3);
  let t4;
  if ($[6] !== form.control) {
    t4 = {
      control: form.control,
      name: "locationNormalizedName"
    };
    $[6] = form.control;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const normalizedName = useWatch(t4);
  const latError = form.formState.errors.latitude;
  const lonError = form.formState.errors.longitude;
  const showError = !!latError || !!lonError;
  const locationStatus = showError ? "error" : latitude && longitude && normalizedName ? "success" : "default";
  let t5;
  if ($[8] !== form || $[9] !== isMobile || $[10] !== openModal) {
    t5 = () => {
      if (isMobile) {
        openModal(ModalTypeEnum.GENERIC_SHEET, {
          className: "w-full",
          side: "bottom",
          children: <SpecificLocationModalContent form={form} />,
          title: "Pick location on map"
        });
        return;
      } else {
        openModal(ModalTypeEnum.GENERIC_DIALOG, {
          children: <SpecificLocationModalContent form={form} />,
          title: "Pick location on map"
        });
      }
    };
    $[8] = form;
    $[9] = isMobile;
    $[10] = openModal;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handlePickSpecificLocation = t5;
  const handleThumbnailClick = onPickLocation ?? handlePickSpecificLocation;
  let t6;
  if ($[12] !== form) {
    t6 = location => {
      form.setValue("latitude", location.lat);
      form.setValue("longitude", location.lon);
      form.setValue("locationNormalizedName", location.display_name);
      form.setValue("parishName", location.address.village || location.address.suburb);
      form.setValue("municipalityName", location.address.county);
      form.setValue("districtName", location.address.city);
    };
    $[12] = form;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const handleSelect = t6;
  let t7;
  if ($[14] !== handleSelect || $[15] !== handleThumbnailClick || $[16] !== isMobile || $[17] !== latitude || $[18] !== locationStatus || $[19] !== longitude || $[20] !== normalizedName || $[21] !== showError || $[22] !== t) {
    t7 = {
      handleThumbnailClick,
      handleSelect,
      showError,
      isMobile,
      latitude,
      longitude,
      normalizedName,
      locationStatus,
      t
    };
    $[14] = handleSelect;
    $[15] = handleThumbnailClick;
    $[16] = isMobile;
    $[17] = latitude;
    $[18] = locationStatus;
    $[19] = longitude;
    $[20] = normalizedName;
    $[21] = showError;
    $[22] = t;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
}